/* camelcase */
export default {
    actual: ['required', 'trim', 'string'],
    expected: ['required', 'trim', 'string'],
    steps: ['required', 'trim', 'string'],
};
